module.exports = __webpack_public_path__ + "img/sld_abt_check_b1_dark.364e1bf3.svg";